import script from "./UserCreateStoreAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreateStoreAccess.vue?vue&type=script&setup=true&lang=js"

import "./UserCreateStoreAccess.vue?vue&type=style&index=0&id=07e2e606&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e2e606"]])

export default __exports__